import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useSprings, animated } from "@react-spring/web";

const ToolsStrategySection = () => {
  const items = [
    "Детализируем вашу текущую ситуацию и выявляем ключевые точки для роста.",
    "Разрабатываем индивидуальную стратегию, которая увеличит доходы и эффективность.",
    "Внедрим решения, которые сохранят баланс между бизнесом и личной жизнью.",
    "Помощь в преодолении внутренних и внешних барьеров.",
    "Обеспечим практическую поддержку на каждом этапе трансформации.",
  ];

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const springs = useSprings(
    items.length,
    items.map((_, index) => ({
      from: { opacity: 0, transform: "translateY(20px)" },
      to: inView
        ? { opacity: 1, transform: "translateY(0px)" }
        : { opacity: 0, transform: "translateY(20px)" },
      delay: index * 400,
      config: { tension: 120, friction: 14 },
    }))
  );

  return (
    <Box
      ref={sectionRef}
      sx={{
        background: "#000",
        color: "#fff",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: "center",
        position: "relative",
        minHeight: { xs: "auto", md: "80vh" },
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "flex-start", md: "center" },
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          mx: "auto",
          mb: 6,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            mb: 0,
            lineHeight: 1.3,
            fontSize: {
              xs: "2.1rem",
              md: "3.3rem",
            },
          }}
        >
          Уникальное предложение:
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{
          maxWidth: "900px",
        }}
      >
        <Grid item xs={12} md={8}>
          <List>
            {springs.map((style, index) => (
              <animated.div key={index} style={style}>
                <ListItem
                  sx={{
                    justifyContent: "center",
                    alignItems: "flex-start",
                    mb: { xs: 2, md: 4 },
                    textAlign: "left",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: "auto",
                      marginRight: 2,
                      marginTop: "4px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="url(#gradient)"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      width="28px"
                      height="28px"
                    >
                      <defs>
                        <linearGradient
                          id="gradient"
                          x1="0%"
                          y1="0%"
                          x2="100%"
                          y2="0%"
                        >
                          <stop offset="0%" stopColor="#7363df" />
                          <stop offset="100%" stopColor="#07a546" />
                        </linearGradient>
                      </defs>
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </ListItemIcon>
                  <ListItemText
                    primary={items[index]}
                    primaryTypographyProps={{
                      sx: {
                        lineHeight: "1.5",
                        mt: "5px",
                      },
                    }}
                  />
                </ListItem>
              </animated.div>
            ))}
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ToolsStrategySection;
